import * as React from "react";
import { FormGroup, FormHelperText, HelperText, HelperTextItem, Text, Tooltip, Gallery, GalleryItem, Card, CardHeader, CardTitle, CardBody, Bullseye, Badge} from "@patternfly/react-core";
import { CheckCircleIcon } from "@patternfly/react-icons";
import "./CategorySelectionComponent.css";

export const CategorySelectionComponent = ({ categories, selectedCategories, toggleCategorySelection, isRequired, errorMessage}) => {
const isSelected = (category) => selectedCategories.some((c) => c.id === category.id);

  return (
    <FormGroup label="Category" isRequired={isRequired}>
      <Gallery
        hasGutter
        minWidths={{ default: "400px", md: "200px" }}
        className="category-gallery"
      >
        {categories.map((category) => {
          const selected = isSelected(category);
          const iconUrl = category.icon_url;

          return (
            <GalleryItem key={category.id} className="category-gallery-item">
              <Tooltip content={category.description}>
                <Card
                  onClick={(e) => toggleCategorySelection(e, category)}
                  isSelectable
                  isSelected={selected}
                  isHoverable
                  role="option"
                  aria-selected={selected}
                  className={`category-card ${selected ? "selected" : ""}`}
                >
                  <div className="card-top-content">
                    <CardHeader className="category-card-header">
                      <Bullseye>
                        <img
                          src={iconUrl}
                          alt={category.name}
                          className="category-icon"
                        />
                      </Bullseye>
                      {selected && (
                        <CheckCircleIcon className="check-circle-icon" />
                      )}
                    </CardHeader>
                    <div className="title-container">
                      <CardTitle className="category-title">
                        {category.name}
                      </CardTitle>
                    </div>
                  </div>

                  <CardBody className="category-card-body">
                    <Badge className="points-badge">
                      {category.points} Points
                    </Badge>
                  </CardBody>
                </Card>
              </Tooltip>
            </GalleryItem>
          );
        })}
      </Gallery>

      <FormHelperText>
        <HelperText>
          <HelperTextItem variant={errorMessage ? "error" : "default"}>
            <Text component="small">
              {errorMessage || "You can choose up to a maximum of 3 categories"}
            </Text>
          </HelperTextItem>
        </HelperText>
      </FormHelperText>
    </FormGroup>
  );
};